module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.headerdata
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "left",
      "margin": "0.1em",
      "margin-top": "-0.2em"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.set_view == 'setViewItems') ? _c('div', {
    staticClass: "card card-box",
    attrs: {
      "id": "setViewCategoryIntro"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h4', [_vm._v("Categories\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'setViewCategories'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.set_view == 'setViewCategories') ? _c('div', {
    staticClass: "card card-box",
    attrs: {
      "id": "setViewItemsIntro"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h4', [_vm._v("Items in shop\r\n            "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'setViewItems';
        _vm.setAllProducts();
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.set_view == 'setViewCategories') ? _c('div', {
    staticClass: "card card-box",
    attrs: {
      "id": "setViewCategories"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [_vm._v("Categories "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("(" + _vm._s(Object.keys(_vm.sellpoint.business_categories).length) + ")")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [((Object.keys(_vm.sellpoint.business_categories).length > 0)) ? _c('div', {
    key: _vm.componentKey
  }, _vm._l((_vm.sellpoint.business_categories), function(category, index) {
    return _c('div', {
      staticClass: "card card-box-fl"
    }, [_c('h5', [_c('a', {
      staticClass: "card-link",
      on: {
        "click": function($event) {
          _vm.setCategoryProducts(category)
        }
      }
    }, [_vm._v("\r\n                    " + _vm._s(category.business_category_name) + "\r\n                    "), _vm._m(2, true)])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.set_view == 'setViewItems') ? _c('div', {
    staticClass: "card card-box",
    attrs: {
      "id": "setViewItems"
    }
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4', [(Object.keys(_vm.category).length > 0) ? _c('span', [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = 'setViewCategories';
        _vm.products = {};
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-left"
  })]), _vm._v(" Items in "), _c('b', [_vm._v(_vm._s(_vm.category.business_category_name))])]) : _c('span', [_vm._v("Items in Shop")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "13px"
    }
  }, [_vm._v("Total: " + _vm._s(_vm.products.length))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div', [_c('table', [_vm._m(3), _vm._v(" "), _vm._l((_vm.products), function(product, index) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_vm._v(_vm._s((index + 1)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_c('div', {
      staticClass: "col-xs-3"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-9"
    }, [_c('p', [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sm-x"
    }, [_vm._v("₦‎" + _vm._s(product.product_items[0].product_item_price_f))])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("8")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "5%"
      }
    }, [_c('a', {
      staticClass: "card-link",
      attrs: {
        "href": '/manage/items/' + product.product_url_name
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-right",
      staticStyle: {
        "color": "#5703a5"
      }
    })])])])
  })], 2)])])]) : _vm._e(), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('p', [_vm._v("Search for items")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "border-radius": "8px"
    },
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "margin-top": "-0.1em"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "font-size": "13px",
      "border-radius": "8px",
      "background": "#5703a5",
      "line-height": "0.8",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/manage/add/categories"
    }
  }, [_vm._v("\r\n                  Add new Category "), _c('i', {
    staticClass: "fas fa-angle-right",
    staticStyle: {
      "color": "#ffffff"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "18px"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_c('th', [_vm._v("-")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding-left": "1em",
      "padding-bottom": "1em",
      "font-size": "0"
    }
  }, [_vm._v("item")]), _vm._v(" "), _c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-box"
  }, [_c('div', {
    staticClass: "card-head"
  }, [_c('h4')]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding-top": "2em",
      "padding-bottom": "4em"
    },
    attrs: {
      "id": ""
    }
  }, [_c('div')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "block",
      "position": "fixed",
      "width": "100%",
      "bottom": "4.6em",
      "background": "#ffffff",
      "z-index": "10000"
    },
    attrs: {
      "id": "xInfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/manage/add/items"
    }
  }, [_vm._v("\r\n        Add Items to Shop")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-053c458e"}!./src/pages/Manage/Items/template.html
// module id = 528
// module chunks = 0